// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3xfih","rightAdornment":"Header_rightAdornment__3nmeO"};